/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiplomeCertificationIfapmeFichierGridDto
 */
export interface DiplomeCertificationIfapmeFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationIfapmeFichierGridDto
     */
    iddiplomeCertificationIfapmeFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationIfapmeFichierGridDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof DiplomeCertificationIfapmeFichierGridDto
     */
    typeAcquisFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationIfapmeFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DiplomeCertificationIfapmeFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationIfapmeFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DiplomeCertificationIfapmeFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DiplomeCertificationIfapmeFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the DiplomeCertificationIfapmeFichierGridDto interface.
 */
export function instanceOfDiplomeCertificationIfapmeFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DiplomeCertificationIfapmeFichierGridDtoFromJSON(json: any): DiplomeCertificationIfapmeFichierGridDto {
    return DiplomeCertificationIfapmeFichierGridDtoFromJSONTyped(json, false);
}

export function DiplomeCertificationIfapmeFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiplomeCertificationIfapmeFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iddiplomeCertificationIfapmeFichier': !exists(json, 'iddiplomeCertificationIfapmeFichier') ? undefined : json['iddiplomeCertificationIfapmeFichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'typeAcquisFichier': !exists(json, 'typeAcquisFichier') ? undefined : json['typeAcquisFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function DiplomeCertificationIfapmeFichierGridDtoToJSON(value?: DiplomeCertificationIfapmeFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iddiplomeCertificationIfapmeFichier': value.iddiplomeCertificationIfapmeFichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'typeAcquisFichier': value.typeAcquisFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

